import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";

import {
  RegisterReducer,
  verifyTimeReducer,
  resendEmailReducer,
  verifyEmailReducer,
  updateUserReducer,
  forgotPasswordReducer,
  allUsersReducer,
  updateRoleReducer,
  updateAvatarReducer
} from "./redux/reducers/userReducers";

import {
  exportUpcExcelReducer,
  mappingReducer,
  mappingImportReducer,
  myMappingsReducer,
  myUpcSlipsReducer,
  upcScanReducer
} from "./redux/reducers/upcScanReducer";

import { allProductsReducer, productReducer, updateProductReducer } from "./redux/reducers/productReducers";
import {
  adminStatsReducer,
  adminStoresReducer,
  adminStoreMutateReducer,
  adminUsersReducer,
  adminUserMutateReducer,
  priceBookReducer,
  priceBookMutateReducer,
  priceBookImportReducer,
  wholesalePriceBookReducer,
  wholesalePriceBookMutateReducer,
  wholesalePriceBookImportReducer,
} from "./redux/reducers/adminReducer";

const reducer = combineReducers({
  register: RegisterReducer,
  verifyTime: verifyTimeReducer,
  resendEmail: resendEmailReducer,
  verifyEmailStore: verifyEmailReducer,
  updateUser: updateUserReducer,
  forgotPassword: forgotPasswordReducer,
  allUsers: allUsersReducer,
  updateRole: updateRoleReducer,
  updateAvatar: updateAvatarReducer,

  upcScan: upcScanReducer,
  myUpcSlips: myUpcSlipsReducer,
  exportUpcExcel: exportUpcExcelReducer,
  product: productReducer,
  products: allProductsReducer,

  productMessage: updateProductReducer,


  myMappings: myMappingsReducer,
  mapping: mappingReducer,
  mappingImport: mappingImportReducer,

  adminStats: adminStatsReducer,
  adminStores: adminStoresReducer,
  adminStoreMutate: adminStoreMutateReducer,
  adminUsers: adminUsersReducer,
  adminUserMutate: adminUserMutateReducer,
  priceBook: priceBookReducer,
  priceBookMutate: priceBookMutateReducer,
  priceBookImport: priceBookImportReducer,
  wholesalePriceBook: wholesalePriceBookReducer,
  wholesalePriceBookMutate: wholesalePriceBookMutateReducer,
  wholesalePriceBookImport: wholesalePriceBookImportReducer,
});

const initialState = {};
const middleware = [thunk];

// ✅ Enable Redux DevTools only in development
const composeEnhancers =
  process.env.NODE_ENV === "development" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const store = createStore(
  reducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
